import React from 'react';
import PageTemplate from './../ui/page_template';
import Welcome from './../Welcome';
import {withTranslation} from 'react-i18next';

const Home = (props) => {
    const {t} = props
    return (
        <PageTemplate title={t('home_page')}>
            <section className="home">
                <Welcome />
            </section>
        </PageTemplate>
    )
}
export default withTranslation()(Home);
